import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Avatar,
  Rating,
  Container,
  Grid,
} from "@mui/material";

const UserReviews = ({ currentValue, userReviews }) => {
  useEffect(() => {
    if (currentValue == "reviews") {
      reviews.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentValue]);

  const reviews = useRef();
  if (!userReviews.length) {
    return <></>;
  } else {
    return (
      <Container className="mb-16">
        <Box style={{ width: "50vw" }}>
          <Stack>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  ref={reviews}
                >
                  Reviews
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  component="legend"
                  style={{ color: "rgba(250, 131, 25, 1)" }}
                >
                  View All
                </Typography>
              </Stack>
            </Stack>

            <Grid container justifyContent="space-between">
              {/* reviews */}
              {userReviews.map((item) => (
                <Grid item sm={5}>
                  <Stack direction="row" className="mb-4" spacing={2}>
                    <Stack>
                      <Avatar
                        alt={item.reviewerName}
                        src="/static/images/avatar/3.jpg"
                      />
                    </Stack>
                    <Stack>
                      <Typography component="legend">
                        {item.reviewerName}
                      </Typography>
                      <Rating name="read-only" value={item.rating} readOnly />
                      <Typography variant="body2" gutterBottom>
                        {item.comment}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              ))}

              {/* <Grid item sm={5}>
                <Stack direction="row" className="mb-4" spacing={2}>
                  <Stack>
                    <Avatar
                      alt="Cindy Baker"
                      src="/static/images/avatar/3.jpg"
                    />
                  </Stack>
                  <Stack>
                    <Typography component="legend">John Doe</Typography>
                    <Rating name="read-only" value={4} readOnly />
                    <Typography variant="body2" gutterBottom>
                      What a great experience using Amaanat! I booked all of my
                      flights for my gap year through Amannat and never had any
                      issues. When I had to cancel a flight because of an
                      emergency, Amaanat support helped me.
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>

              
              <Grid item sm={5}>
                <Stack direction="row" className="mb-4" spacing={2}>
                  <Stack>
                    <Avatar
                      alt="Cindy Baker"
                      src="/static/images/avatar/3.jpg"
                    />
                  </Stack>
                  <Stack>
                    <Typography component="legend">John Doe</Typography>
                    <Rating name="read-only" value={4} readOnly />
                    <Typography variant="body2" gutterBottom>
                      What a great experience using Amaanat! I booked all of my
                      flights for my gap year through Amannat and never had any
                      issues. When I had to cancel a flight because of an
                      emergency, Amaanat support helped me.
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>

              
              <Grid item sm={5}>
                <Stack direction="row" className="mb-4" spacing={2}>
                  <Stack>
                    <Avatar
                      alt="Cindy Baker"
                      src="/static/images/avatar/3.jpg"
                    />
                  </Stack>
                  <Stack>
                    <Typography component="legend">John Doe</Typography>
                    <Rating name="read-only" value={4} readOnly />
                    <Typography variant="body2" gutterBottom>
                      What a great experience using Amaanat! I booked all of my
                      flights for my gap year through Amannat and never had any
                      issues. When I had to cancel a flight because of an
                      emergency, Amaanat support helped me.
                    </Typography>
                  </Stack>
                </Stack>
              </Grid> */}
            </Grid>
          </Stack>
        </Box>
      </Container>
    );
  }
};

export default UserReviews;
